export default __webpack_public_path__ + "static/7-8a7b1a9baf5dd9fcbb9e00030163965d.png";